import Head from "next/head";
import Promo, { PromoBanner } from "../../components/Home/Promo";
import React from "react";
import Accordion from "../../components/sections/Accordion";
import styles from "./index.module.scss";
import Button from "../../components/UI/Button";
import Link from "next/link";

export default function dataProtection() {
  return (
    <div className={`container ${styles.root}`}>
      <Head>
        <title>
          How Apphud Protects Your Data - GDPR/CCPA Compliance – Apphud
        </title>
        <link rel="canonical" href="https://apphud.com/data-protection" />
        <meta
          property="og:title"
          content="How Apphud Protects Your Data - GDPR/CCPA Compliance - Apphud"
        />
        <meta
          property="og:description"
          content="Customers Data Protection is the highest Apphud priority. We guarantee that all of your data is stored securely with encryption. Read the Docs for more details."
        />
        <meta property="og:url" content="https://apphud.com/data-protection" />
        <meta
          property="twitter:title"
          content="How Apphud Protects Your Data - GDPR/CCPA Compliance - Apphud"
        />
        <meta
          property="twitter:description"
          content="Customers Data Protection is the highest Apphud priority. We guarantee that all of your data is stored securely with encryption. Read the Docs for more details."
        />
        <meta
          property="twitter:url"
          content="https://apphud.com/data-protection"
        />
        <meta
          name="description"
          content="How Apphud Protects Your Data - GDPR/CCPA Compliance"
        />
      </Head>
      <div className={styles.title}>
        <div className="container">
          <h1>Data Protection</h1>
        </div>
      </div>
      <div className={styles.block}>
        <div className={`${styles.col} ${styles.img}`}>
          <img
            src="/data-protection/1.svg"
            alt="alt"
            width="280"
            height="236"
          />
        </div>
        <div className={styles.col}>
          <h3>How Apphud Protects Your Data</h3>
          <p>
            Customers Data Protection is the highest Apphud priority. We
            guarantee that all of your data is stored securely with encryption.
            Moreover, our qualified engineering team is working hard to provide
            the most stable and accurate service on the market. Please, check
            our{" "}
            <a href="https://status.apphud.com/" target="_blank">
              Status Page
            </a>{" "}
            and{" "}
            <a
              href="https://apphud.com/blog/apphud-data-accuracy-research"
              target="_blank"
            >
              Accuracy Research
            </a>{" "}
            to ensure.
          </p>
        </div>
      </div>
      <div className={styles.block}>
        <div className={`${styles.col} ${styles.img}`}>
          <img
            src="/data-protection/2.svg"
            alt="alt"
            width="282"
            height="275"
          />
        </div>
        <div className={styles.col}>
          <h3>GDPR/CCPA Compliance</h3>
          <p>
            Apphud can be used by EU and California companies as well as
            developers who are subject to GDPR compliance requirements.
          </p>
          <p>
            In the case of processing your end users' personal data, Apphud is
            considered a "processor". As such, you, as the "controller" of your
            own application data, are responsible in your own privacy policy for
            disclosing the personal user information you submit to us.
          </p>
          <p>
            For more information see our{" "}
            <a href="https://legal.apphud.com/terms" target="_blank">
              Terms
            </a>{" "}
            and{" "}
            <a href="https://legal.apphud.com/privacy" target="_blank">
              Privacy policy
            </a>{" "}
            and our{" "}
            <a href="https://legal.apphud.com/apphud-dpa" target="_blank">
              Data Processing Addendum
            </a>
            .
          </p>
        </div>
      </div>
      <div className="accordion">
        <div className="container">
          <h2>FAQ</h2>
          <div className="accordion-items">
            <Accordion title="Is my data encrypted?">
              Yes, Apphud uses standard production encryption using 128-bit AES
              in CBC mode and PKCS7 padding, with HMAC using SHA256 or
              equivalent for authentication.
            </Accordion>
            <Accordion title="Do you share my data with third parties?">
              No, we do not share your data with anyone. All the data we collect
              is leveraged to provide you with analytics and to improve our
              service.
            </Accordion>
            <Accordion title="Where do you store data?">
              All your and your users data stored in reliable infrastructure and
              services, located in EU and US.
            </Accordion>

            <Accordion title="How to delete my customer data?">
              For customer data deletion requests, please&nbsp;
              <Link href={"/contact"}>
                <a>contact us.</a>
              </Link>
            </Accordion>

            <Accordion title="How Apphud team access Customer data?">
              Apphud limits its personnel’s access to Customer Data on a "need
              to know" basis by using secure logins and passwords, including
              multi-factor authentication for Cloud Hosting administrator access
              and individually assigned Secure Socket Shell (SSH) keys for
              external engineer access. Apphud Prohibits the personnel from
              storing Customer Data on portable electronic storage devices such
              as computer laptops, portable drives and similar devices.
            </Accordion>

            <Accordion title="In which cases can you access my data?">
              Your data can be viewed upon request to customer service and only
              in order to investigate your question. Your data may also be used
              for making annual reports and other marketing purposes, only in an
              aggregated and anonymous form, i.e. across all Apphud database
              without tying to a specific app. Other forms of data access are
              prohibited.
            </Accordion>

            <Accordion title="What data Apphud collect and store?">
              <div className={styles.numItem}>
                <div>
                  <img
                    src={"/data-protection/3.svg"}
                    alt="alt"
                    width="20"
                    height="20"
                  />
                </div>
                <div>
                  <p>
                    While using our Service, we may ask you to provide us with
                    certain personally identifiable information that can be used
                    to contact or identify you ("Personal Data"). Personally
                    identifiable information may include, but is not limited to:
                  </p>
                  <ul>
                    <li>Email address</li>
                    <li>First name and Last name</li>
                    <li>Cookies and Usage Data</li>
                    <li>Address</li>
                    <li>Phone number</li>
                    <li>Personal description and photograph</li>
                    <li>Login and password details</li>
                    <li>
                      Information about your apps: app name, bundle ID, App
                      Store shared secret key, information about subscription
                      and other in-app purchases
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.numItem}>
                <div>
                  <img
                    src={"/data-protection/4.svg"}
                    alt="alt"
                    width="20"
                    height="20"
                  />
                </div>
                <div>
                  <p>
                    For more details, please walk through Privacy Policy and
                    Data Processing Addendum, or{" "}
                    <Link href={"/contact"}>
                      <a>contact us.</a>
                    </Link>
                  </p>
                </div>
              </div>
            </Accordion>
          </div>
        </div>
      </div>
      <div className={styles.question}>
        <h2>Got a question?</h2>
        <p>
          Have any questions regarding Apphud
          <br /> privacy, GDPR/CCPA, etc.?
        </p>
        <Link href={"/contact"}>
          <Button title="Contact us" />
        </Link>
      </div>
      <PromoBanner />
    </div>
  );
}
